import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleViewer from '../../components/ArticleViewer';
import { PUBLIC_ROUTES } from '../../../../constants/routes';
import '../getting-started/HelpCategoryPage.css';

/**
 * Account Access Problems Article Page
 */
const AccountAccess = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <ArticleViewer 
              title="Account Access Problems"
              showQA={true}
              articleId="account-access"
            >
              <div className="article-content">
                <p>
                  Having trouble accessing your account? Here's how to resolve common login issues.
                </p>
                
                <h2>Forgot Password</h2>
                <p>To reset your password:</p>
                <ol>
                  <li>Go to the login screen</li>
                  <li>Tap "Forgot Password"</li>
                  <li>Enter your email address</li>
                  <li>Check your email for the reset link</li>
                  <li>Follow the instructions to create a new password</li>
                </ol>

                <h2>Can't Receive Verification Code</h2>
                <p><strong>Solutions:</strong></p>
                <ul>
                  <li>Check your spam/junk folder</li>
                  <li>Verify your email address is correct</li>
                  <li>Wait a few minutes and request a new code</li>
                  <li>Try using SMS verification instead</li>
                  <li>Contact support if codes aren't arriving</li>
                </ul>

                <h2>Account Locked</h2>
                <p>
                  If your account is locked due to too many failed login attempts:
                </p>
                <ul>
                  <li>Wait 30 minutes and try again</li>
                  <li>Use the "Forgot Password" option to reset</li>
                  <li>Contact support if the lock persists</li>
                </ul>

                <h2>Two-Factor Authentication Issues</h2>
                <p>
                  If you're having trouble with 2FA:
                </p>
                <ul>
                  <li>Make sure your device time is set correctly</li>
                  <li>Check that you're using the correct authenticator app</li>
                  <li>Use backup codes if available</li>
                  <li>Contact support to disable 2FA if needed</li>
                </ul>
              </div>
            </ArticleViewer>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default AccountAccess;
